var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef, useMemo, useCallback, useState, useLayoutEffect, } from 'react';
export const useConstructor = (callback) => {
    const ref = useRef(false);
    if (!ref.current) {
        callback();
    }
    ref.current = true;
};
/**
 * unmountされているかどうかの取得
 * @deprecated TS化済: src/hooks/lifecycle/useUnmountRef.ts
 * @returns {React.MutableRefObject<boolean>}
 */
export const useUnmountRef = () => {
    const unmountRef = useRef(false);
    useEffect(() => () => {
        unmountRef.current = true;
    }, []);
    return unmountRef;
};
/**
 * 更新前のstateを返す
 * @deprecated TS化済: src/hooks/lifecycle/usePrevious.ts
 * @returns {React.MutableRefObject}
 */
export const usePrevious = (value) => {
    const ref = useRef();
    const prevRef = useRef();
    return useMemo(() => {
        if (ref.current !== value) {
            prevRef.current = ref.current;
            ref.current = value;
        }
        return prevRef.current;
    }, [value]);
};
/**
 * useEffectのdicMount時の1回起動のみ
 * @deprecated TS化済: src/hooks/lifecycle/useDidMount.ts
 * @param callback
 */
export const useDidMount = (callback) => {
    useEffect(() => {
        callback();
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
/**
 * useEffectのdicMount時の1回起動のみ
 * @param callback
 */
export const useLayoutDidMount = (callback) => {
    useLayoutEffect(() => {
        callback();
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
/**
 * 初回固定結果のuseMemoの結果を返却する
 * @deprecated 以降はutils/hooks/useMemo/useMemoFrozen.tsを利用すること
 * @param callback
 * @returns {unknown}
 */
// eslint-disable-next-line react-hooks/exhaustive-deps
export const useMemoFrozen = (callback) => useMemo(callback, []);
/**
 * promiseのローディング自動更新つきの実行
 * @deprecated TS化済: src/hooks/async/loading/usePromiseDoingCallback.ts
 * @param promiseEvent
 * @param unmountRef
 * @returns {[]}
 */
export const usePromiseDoingCallback = (promiseEvent, unmountRef) => {
    const [doing, changeDoing] = useState(false);
    const callback = useCallback((...arg) => __awaiter(void 0, void 0, void 0, function* () {
        changeDoing(true);
        try {
            return yield promiseEvent(...arg);
        }
        finally {
            if (!unmountRef.current) {
                changeDoing(false);
            }
        }
    }), [promiseEvent, unmountRef, changeDoing]);
    return [callback, doing, changeDoing];
};
/**
 * 指定の関数の実行後にその後の処理を実行するようにwrapする
 * @param originalFunction
 * @param afterCall
 * @returns {(function(...[*]): Promise<void>)|*}
 */
export const useFunctionSetAfterCall = (originalFunction, afterCall) => useCallback((...arg) => __awaiter(void 0, void 0, void 0, function* () {
    yield originalFunction(...arg);
    yield afterCall();
}), [originalFunction, afterCall]);
/**
 * true/false制御用のuse hook
 * @deprecated TS化済: src/hooks/state/useBoolState.ts
 * @param initialState
 * @param callbackChangeTrue
 * @param callbackChangeFalse
 * @returns {{changeTrue: ((function(): void)|*), changeFalse: ((function(): void)|*), boolState: boolean, changeToggle: ((function(): void)|*)}}
 */
export const useBoolState = (initialState = false, callbackChangeTrue = null, callbackChangeFalse = null) => {
    const [boolState, changeBoolState] = useState(initialState);
    const changeTrue = useCallback(() => {
        if (callbackChangeTrue) {
            callbackChangeTrue();
        }
        changeBoolState(true);
    }, [callbackChangeTrue, changeBoolState]);
    const changeFalse = useCallback(() => {
        if (callbackChangeFalse) {
            callbackChangeFalse();
        }
        changeBoolState(false);
    }, [callbackChangeFalse, changeBoolState]);
    const changeToggle = useCallback(() => {
        changeBoolState((prev) => !prev);
    }, [changeBoolState]);
    return {
        boolState,
        changeFalse,
        changeToggle,
        changeTrue,
    };
};
